var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_6418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 2V0H16.0002V2H13.5002V0H10.5002V2H8.00024V0H5.00024V2H2.00024V20.5C2.00024 21.4283 2.36899 22.3185 3.02537 22.9749C3.68175 23.6313 4.57199 24 5.50024 24H18.5002C19.4285 24 20.3187 23.6313 20.9751 22.9749C21.6315 22.3185 22.0002 21.4283 22.0002 20.5V2H19.0002ZM19.0002 20.5C19.0002 20.6326 18.9476 20.7598 18.8538 20.8536C18.76 20.9473 18.6329 21 18.5002 21H5.50024C5.36764 21 5.24046 20.9473 5.14669 20.8536C5.05292 20.7598 5.00024 20.6326 5.00024 20.5V5H19.0002V20.5ZM17.0002 10H7.00024V7H17.0002V10ZM13.0002 15H7.00024V12H13.0002V15Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_6418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.2f7af3cf91c0882ac1fee1c46534eaac.svg";
export { ForwardRef as ReactComponent };